module.exports = __webpack_public_path__ + "static/media/thedeer.1414ccd7.png";